import React, { useState } from "react";
import { signInWithEmailAndPassword, sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../firebase";
import { Link, useNavigate } from "react-router-dom";

function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate("/admin/dashboard");
    } catch (err) {
      setError(err.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  const onReset = async () => {
    if (!email) {
      setError("Enter your email to receive a reset link.");
      return;
    }
    setError("");
    try {
      await sendPasswordResetEmail(auth, email);
      alert("Password reset email sent.");
    } catch (err) {
      setError(err.message || "Could not send reset email");
    }
  };

  return (
    <section className="py-16 min-h-[70vh] flex items-center justify-center bg-white">
      <div className="w-full max-w-md bg-gray-50 border border-gray-200 rounded-2xl shadow-sm p-6">
        <div className="mb-6 text-center">
          <p className="text-sm font-medium text-gray-500 flex items-center gap-2 justify-center">
            <span className="inline-block h-1.5 w-1.5 rounded-full" style={{ backgroundColor: "rgb(232, 51, 16)" }} />
            Admin
          </p>
          <h1 className="text-2xl font-extrabold text-gray-900">Sign in to Continue</h1>
        </div>

        {error && (
          <div className="mb-4 text-sm font-semibold text-red-700 bg-red-50 border border-red-200 rounded-md px-3 py-2">
            {error}
          </div>
        )}

        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-amber-400"
              placeholder="you@example.com"
            />
          </div>
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-amber-400"
              placeholder="••••••••"
            />
          </div>
          <div className="flex items-center justify-between">
            <button
              type="submit"
              disabled={loading}
              className="flex items-center gap-2 font-semibold bg-[#211033] text-white border border-teal-700 rounded-full py-2 px-5 hover:bg-white hover:text-[#211033] ease-in duration-300 shadow disabled:opacity-60 disabled:cursor-not-allowed"
            >
              {loading ? "Signing in..." : "Sign In"}
            </button>
            <button type="button" onClick={onReset} className="text-sm font-semibold text-teal-700 hover:underline">
              Forgot password?
            </button>
          </div>
        </form>

        <div className="mt-6 text-xs text-gray-500 text-center">
          <Link to="/" className="hover:underline">Back to Home</Link>
        </div>
      </div>
    </section>
  );
}

export default AdminLogin;
